import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'sonner/dist/styles.css';
import './styles/globals.css';
import { initializeProjectKey } from './lib/utils/project-key';
import { installStyleNonce } from './lib/csp-nonce';

installStyleNonce();
initializeProjectKey();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
